import React, { useEffect, useState } from 'react';
import { Download, Share, X } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const DISMISS_KEY = 'ox_pwa_dismissed_at';
const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

export function InstallPrompt() {
  const { isAuthenticated } = useAuth();
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    const dismissed = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (Date.now() - dismissed < 7 * 24 * 3600 * 1000) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    if (isIOS()) setShow(true);
    return () => window.removeEventListener('beforeinstallprompt', onPrompt);
  }, []);

  if (!show || !isAuthenticated) return null;

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, String(Date.now())); setShow(false); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === 'accepted') setShow(false); else dismiss();
  };

  return (
    <div className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 sm:w-[380px] z-[60] bg-[#27292E] text-white rounded-2xl shadow-2xl p-3.5 flex items-start gap-3" data-testid="pwa-install-banner">
      <img src="/icons/icon-192.png" alt="" className="w-11 h-11 rounded-xl bg-white shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-bold">Add Ox Resin to your home screen</div>
        {deferred ? (
          <p className="text-xs text-gray-300 mt-0.5">Open the portal like an app — full screen, one tap from your phone.</p>
        ) : (
          <p className="text-xs text-gray-300 mt-0.5 flex items-center gap-1 flex-wrap">Tap <Share className="w-3.5 h-3.5 inline" /> <span className="font-semibold">Share</span> then <span className="font-semibold">“Add to Home Screen”</span>.</p>
        )}
        {deferred && (
          <button type="button" onClick={install} className="mt-2 inline-flex items-center gap-1.5 text-xs font-bold bg-[#006400] hover:bg-[#004d00] rounded-full px-3 py-1.5" data-testid="pwa-install-btn"><Download className="w-3.5 h-3.5" /> Install app</button>
        )}
      </div>
      <button type="button" onClick={dismiss} className="p-1 rounded-lg hover:bg-white/10 shrink-0" aria-label="Dismiss" data-testid="pwa-install-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
}
